import { useRef } from "react";
var NEVER = {};
/**
 * @example
 * ```js
 * function ChangedStatus ({ count }) {
 *   const initialCount = useInitial (() => count)
 *   const hasChanged = count !== initialCount
 *   return <div>{hasChanged ? "Changed" : "Not Changed"}</div>
 * }
 * ```
 */ export function useInitial(factory) {
    var ref = useRef(NEVER);
    if (ref.current === NEVER) {
        ref.current = factory();
    }
    return ref.current;
}
